import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { Session } from "@/features/dashboard/types/session.ts";
import type {
	User,
	UserAssignBranchFormSchema,
	UserCreateFormSchema,
	UserFormSchema,
	UserPinSchema,
	// UserAssignFormSchema,
	// UserCreateFormSchema,
	// UserFormSchema,
} from "@/features/dashboard/types/user.ts";

const userService = {
	...createBaseService<User>("/users"),
	create: async (data: UserCreateFormSchema) => {
		const response = await apiClient.post<{ data: User }>("/users", data);

		return response.data.data;
	},
	updateById: async (data: UserFormSchema) => {
		const response = await apiClient.put<{ data: User }>(`/users/${data.id}`, data);

		return response.data.data;
	},
	updatePinCode: async (data: UserPinSchema) => {
		const response = await apiClient.post<{ data: User }>("/users/pin-code", data);

		return response.data.data;
	},

	updateByIdEmail: async (data: UserFormSchema) => {
		const response = await apiClient.put<{ data: User }>(`/users/${data.id}/email`, data);
		return response.data.data;
	},

	getSessions: async (userId: string) => {
		const response = await apiClient.get<{ data: Session[] }>(`/users/${userId}/sessions`);

		return response.data.data;
	},
	validateEmail: async (email: string) => {
		const response = await apiClient.post<{ data: User }>("/users/validate_email", {
			email,
		});

		return response.data.data;
	},
	validatePassword: async (password: string) => {
		try {
			const response = await apiClient.post<{ data: User }>("/users/validate_password", { password });
			return response.data;
		} catch (error) {
			return { message: "Invalid pin code" };
		}
	},
	listByBranch: async (branchId: string) => {
		console.log("branchId", branchId);
		const response = await apiClient.get<{ data: User[] }>(`/backoffice/users/${branchId}/branch`);

		return response.data.data;
	},
	removeRole: async (data: UserAssignFormSchema) => {
		return await apiClient.put(`/users/${data.user_id}/roles`, data);
	},
	assignRole: async (data: UserAssignFormSchema) => {
		return await apiClient.post(`/users/${data.user_id}/roles`, data);
	},
	assignBranch: async (data: any) => {
		return await apiClient.post(`/users/${data?.data.user_id}/branch`, data?.data);
	},
	removeBranch: async (data: any) => {
		return await apiClient.put(`/users/${data.user_id}/branch`, data);
	},
	// disable: async (id: string): Promise<void> => {
	// 	return await apiClient.post(`/users/${id}/disable`);
	// },
	// enable: async (id: string): Promise<void> => {
	// 	return await apiClient.post(`/users/${id}/enable`);
	// },
};

export default userService;
